import Embed from "quill/blots/embed"
import { escapeText } from "quill/blots/text"
const ATTRIBUTES = ["data-id", "data-label", "contenteditable"]

/**
 * Placeholder format for Quill
 */
export default class Placeholder extends Embed {
	static blotName = "placeholder"
	static tagName = "span"
	static className = "ql-placeholder-content"

	domNode!: HTMLImageElement;

	static create (value: any) {
		let node = super.create(value) as HTMLElement

		node.setAttribute("class", "ql-placeholder-content badge badge-primary")
		node.setAttribute("data-id", value.id)
		node.setAttribute("data-label", value.label)

		// The label can come from stored html (value() reads data-label), so it is set as text: innerHTML would
		// turn markup saved in a label into real elements in the editor.
		node.textContent = value.label

		return node
	}

	static value (domNode: Element) {
		return {
			id: domNode.getAttribute("data-id"),
			label: domNode.getAttribute("data-label")
		}
	}

	/**
	 * Placeholder markup for the print template editor (HugeRTE). The id and label are escaped, so a field name
	 * containing markup or quotes is inserted as text.
	 */
	static getPlaceholderHtml (placeholderId: string, placeholderLabel: string, placeholderColourClass: string = "badge-primary") {
		const id = escapeText(placeholderId)
		const label = escapeText(placeholderLabel)
		return `<span contenteditable="false" class="placeholder-content badge ${placeholderColourClass}" data-id="${id}" data-label="${label}"><span contenteditable="false">${label}</span></span>`
	}
}
